import React from "react";

export default function SQLServer_RIGHT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_RIGHT</h1>
      <p>This is the SQLServer_RIGHT component generated from the SQL JSON.</p>
    </div>
  );
}
